<template>
    <div>
        <section>
            <div class="top-nav-div">
                <div class="top-nav-elements">
                    <a href="#" class="link-block-42 w-inline-block">
                        <img :src="require('@/assets/images/NewSelf_Logo.png')" 
                             sizes="(max-width: 479px) 100vw, 84.03125px"
                             loading="lazy" 
                             class="image-294">
                    </a>
                    <div class="form-nav-div">
                        <a href="#" @click.prevent="questionId > 1 ? questionId-- : null" class="back-link w-inline-block">
                            <div class="text-block-507">&lt;-</div>
                        </a>
                        <div class="form-progress-div">
                            <div>
                                <div class="text-block-508">Step <strong>{{ questionId }}</strong> of <strong>{{ totalQuestions }}</strong></div>
                            </div>
                            <div class="form-precent-div">
                                <div class="text-block-509"><strong>{{ Math.round(((questionId - 1) / totalQuestions) * 100) }}%</strong> Complete</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-block-1442">
                        <div class="text-block-505"></div>
                    </div>
                </div>
            </div>
        </section>

        
        <!-- ... top navigation section remains the same ... -->

        <section class="section-7">
            <div class="questions-div">
                <!-- Current Symptoms -->
                <div class="question-container" v-if="questionId === 1">
                    <div class="question-div-2">
                        <div class="text-block-513">Please describe your current symptoms and health concerns.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="form-group">
                                    <textarea 
                                        v-model="patient.currentSymptoms" 
                                        class="textarea w-input" 
                                        required></textarea>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Skin Conditions -->
                <div class="question-container" v-if="questionId === 2">
                    <div class="question-div-2">
                        <div class="text-block-513">Have you been diagnosed with any skin conditions, wound healing issues, or hair loss disorders?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasSkinConditions', 'Yes')" 
                                       :class="['button-68 w-button', patient.hasSkinConditions === 'Yes' ? 'selected' : '']">
                                       Yes
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasSkinConditions', 'No')" 
                                       :class="['button-68 w-button', patient.hasSkinConditions === 'No' ? 'selected' : '']">
                                       No
                                    </a>
                                </div>
                                <div class="form-group">
                                    <textarea 
                                        v-if="patient.hasSkinConditions === 'Yes'"
                                        v-model="patient.skinConditionsDetails" 
                                        class="textarea w-input" 
                                        placeholder="Please specify the condition(s)"
                                        required></textarea>
                                </div>
                                <input v-if="patient.hasSkinConditions === 'Yes'" type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Symptoms Check -->
                <div class="question-container" v-if="questionId === 3">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you experiencing symptoms such as delayed wound healing, signs of skin aging (e.g., wrinkles, loss of elasticity), hair thinning, or hair loss?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasSymptoms', 'Yes')" 
                                       :class="['button-68 w-button', patient.hasSymptoms === 'Yes' ? 'selected' : '']">
                                       Yes
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasSymptoms', 'No')" 
                                       :class="['button-68 w-button', patient.hasSymptoms === 'No' ? 'selected' : '']">
                                       No
                                    </a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Current Treatments -->
                <div class="question-container" v-if="questionId === 4">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you currently on any treatments or medications for skin conditions, wound healing, or hair loss?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('onTreatments', 'Yes')" 
                                       :class="['button-68 w-button', patient.onTreatments === 'Yes' ? 'selected' : '']">
                                       Yes
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('onTreatments', 'No')" 
                                       :class="['button-68 w-button', patient.onTreatments === 'No' ? 'selected' : '']">
                                       No
                                    </a>
                                </div>
                                <div class="form-group">
                                    <textarea 
                                        v-if="patient.onTreatments === 'Yes'"
                                        v-model="patient.treatmentsDetails" 
                                        class="textarea w-input" 
                                        placeholder="Please list current treatments"
                                        required></textarea>
                                </div>
                                <input v-if="patient.onTreatments === 'Yes'" type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Prior Peptide Use -->
                <div class="question-container" v-if="questionId === 5">
                    <div class="question-div-2">
                        <div class="text-block-513">Have you ever used GHK-Cu (Copper Peptide) or other peptide-based therapies before?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('priorPeptideUse', 'Yes')" 
                                       :class="['button-68 w-button', patient.priorPeptideUse === 'Yes' ? 'selected' : '']">
                                       Yes
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('priorPeptideUse', 'No')" 
                                       :class="['button-68 w-button', patient.priorPeptideUse === 'No' ? 'selected' : '']">
                                       No
                                    </a>
                                </div>
                                <div class="form-group">
                                    <textarea 
                                        v-if="patient.priorPeptideUse === 'Yes'"
                                        v-model="patient.priorPeptideDetails" 
                                        class="textarea w-input" 
                                        placeholder="Please provide details of past usage"
                                        required></textarea>
                                </div>
                                <input type="submit" v-if="patient.priorPeptideUse === 'Yes'" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Allergies -->
                <div class="question-container" v-if="questionId === 6">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have a history of allergic reactions to peptides, copper, or any topical products? </div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasAllergies', 'Yes')" 
                                       :class="['button-68 w-button', patient.hasAllergies === 'Yes' ? 'selected' : '']">
                                       Yes
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasAllergies', 'No')" 
                                       :class="['button-68 w-button', patient.hasAllergies === 'No' ? 'selected' : '']">
                                       No
                                    </a>
                                </div>
                                <div class="form-group">
                                    <textarea 
                                        v-if="patient.hasAllergies === 'Yes'"
                                        v-model="patient.allergiesDetails" 
                                        class="textarea w-input" 
                                        placeholder="Please provide details"
                                        required></textarea>
                                </div>
                                <input type="submit" v-if="patient.hasAllergies === 'Yes'" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Metabolism Disorders -->
                <div class="question-container" v-if="questionId === 7">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have any known copper metabolism disorders, such as Wilson's disease or Menkes disease?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasMetabolismDisorders', 'Yes')" 
                                       :class="['button-68 w-button', patient.hasMetabolismDisorders === 'Yes' ? 'selected' : '']">
                                       Yes
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasMetabolismDisorders', 'No')" 
                                       :class="['button-68 w-button', patient.hasMetabolismDisorders === 'No' ? 'selected' : '']">
                                       No
                                    </a>
                                </div>
                                <div class="form-group">
                                    <textarea 
                                        v-if="patient.hasMetabolismDisorders === 'Yes'"
                                        v-model="patient.metabolismDisordersDetails" 
                                        class="textarea w-input" 
                                        placeholder="Please describe"
                                        required></textarea>
                                </div>
                                <input type="submit" v-if="patient.hasMetabolismDisorders === 'Yes'" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Organ Conditions -->
                <div class="question-container" v-if="questionId === 8">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have any kidney or liver conditions?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasOrganConditions', 'Yes')" 
                                       :class="['button-68 w-button', patient.hasOrganConditions === 'Yes' ? 'selected' : '']">
                                       Yes
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasOrganConditions', 'No')" 
                                       :class="['button-68 w-button', patient.hasOrganConditions === 'No' ? 'selected' : '']">
                                       No
                                    </a>
                                </div>
                                <div class="form-group">
                                    <textarea 
                                        v-if="patient.hasOrganConditions === 'Yes'"
                                        v-model="patient.organConditionsDetails" 
                                        class="textarea w-input" 
                                        placeholder="Please provide details"
                                        required></textarea>
                                </div>
                                <input type="submit" v-if="patient.hasOrganConditions === 'Yes'" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Pregnancy -->
                <div class="question-container" v-if="questionId === 9">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you pregnant, planning to become pregnant, or currently breastfeeding?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('isPregnant', 'Yes')" 
                                       :class="['button-68 w-button', patient.isPregnant === 'Yes' ? 'selected' : '']">
                                       Yes
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('isPregnant', 'No')" 
                                       :class="['button-68 w-button', patient.isPregnant === 'No' ? 'selected' : '']">
                                       No
                                    </a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Skincare Routine -->
                <div class="question-container" v-if="questionId === 10">
                    <div class="question-div-2">
                        <div class="text-block-513">Please describe your current skincare or hair care routine, including any products or supplements you are using.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="form-group">
                                    <textarea 
                                        v-model="patient.skinCareRoutine" 
                                        class="textarea w-input" 
                                        placeholder="Include any products or supplements you are using"
                                        required></textarea>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Substance Use -->
                <div class="question-container" v-if="questionId === 11">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you use tobacco, alcohol, or recreational drugs?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('useSubstances', 'Yes')" 
                                       :class="['button-68 w-button', patient.useSubstances === 'Yes' ? 'selected' : '']">
                                       Yes
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('useSubstances', 'No')" 
                                       :class="['button-68 w-button', patient.useSubstances === 'No' ? 'selected' : '']">
                                       No
                                    </a>
                                </div>
                                <div class="form-group">
                                    <textarea 
                                        v-if="patient.useSubstances === 'Yes'"
                                        v-model="patient.substanceDetails" 
                                        class="textarea w-input" 
                                        placeholder="Please specify type and frequency"
                                        required></textarea>
                                </div>
                                <input type="submit"  v-if="patient.useSubstances === 'Yes'" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>
                        <!-- Diet -->
                <div class="question-container" v-if="questionId === 12">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have a balanced diet that includes sources of essential nutrients and antioxidants?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasBalancedDiet', 'Yes')" 
                                       :class="['button-68 w-button', patient.hasBalancedDiet === 'Yes' ? 'selected' : '']">
                                       Yes
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('hasBalancedDiet', 'No')" 
                                       :class="['button-68 w-button', patient.hasBalancedDiet === 'No' ? 'selected' : '']">
                                       No
                                    </a>
                                </div>
                                <div class="form-group">
                                    <textarea 
                                        v-if="patient.hasBalancedDiet === 'No'"
                                        v-model="patient.dietaryDetails" 
                                        class="textarea w-input" 
                                        placeholder="Please describe any dietary concerns"
                                        required></textarea>
                                </div>
                                <input v-if="patient.hasBalancedDiet === 'No'" type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                

                <!-- Informed Consent -->
                <div class="question-container" v-if="questionId === 13">
                    <div class="question-div-2">
                        <div class="text-block-513">Please review and acknowledge the informed consent</div>
                        <div class="consent-text" v-html="consentText"></div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="submitForm">
                                <div class="div-block-1487">
                                    <a href="#" 
                                       @click.prevent="handleYesNo('consent', 'accept')" 
                                       :class="['button-68 w-button', patient.consent === 'accept' ? 'selected' : '']">
                                       I Accept
                                    </a>
                                    <a href="#" 
                                       @click.prevent="handleYesNo('consent', 'decline')" 
                                       :class="['button-68 w-button', patient.consent === 'decline' ? 'selected' : '']">
                                       I Decline
                                    </a>
                                </div>
                                <button type="submit" 
                                        class="form-button w-button" 
                                        :disabled="loading">
                                    {{ loading ? 'Submitting...' : 'Complete Screening' }}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div style="height: 320px;"></div>
    </div>
</template>

<script>
export default {
    name: 'GHKCuForm',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            questionId: 1,
            totalQuestions: 13,
            loading: false,
            patient: {
                currentSymptoms: '',
                hasSkinConditions: null,
                skinConditionsDetails: '',
                hasSymptoms: null,
                onTreatments: null,
                treatmentsDetails: '',
                priorPeptideUse: null,
                priorPeptideDetails: '',
                hasAllergies: null,
                allergiesDetails: '',
                hasMetabolismDisorders: null,
                metabolismDisordersDetails: '',
                hasOrganConditions: null,
                organConditionsDetails: '',
                isPregnant: null,
                skinCareRoutine: '',
                useSubstances: null,
                substanceDetails: '',
                hasBalancedDiet: null,
                dietaryDetails: '',
                selectedGoals: [],
                otherGoals: '',
                consent: null
            },
            treatmentGoals: [
                { id: 'woundHealing', label: 'Improve wound healing' },
                { id: 'antiAging', label: 'Reduce signs of aging (wrinkles, loss of elasticity)' },
                { id: 'hairGrowth', label: 'Promote hair growth/reduce hair loss' },
                { id: 'skinTexture', label: 'Improve skin texture and tone' },
                { id: 'scarReduction', label: 'Reduce appearance of scars' },
                { id: 'inflammation', label: 'Reduce skin inflammation' },
                { id: 'other', label: 'Other goals' }
            ],
            consentText: `
                <div class="consent-content">
                    GHK-Cu (Copper Peptide) is a naturally occurring peptide composed of glycine, histidine, and lysine combined with copper, known for its regenerative properties in skin and tissue repair, anti-aging effects, and promotion of hair growth. It can be used in various forms, including topical applications and, in some cases, injectable treatments. While scientific studies have shown promising results, it is important to note that the U.S. Food and Drug Administration (FDA) has not approved GHK-Cu for treating medical conditions. Its use is considered supplemental or cosmetic, and it should be used under the guidance of a healthcare provider. The purpose of this consent form is to ensure you understand the rationale for considering this therapy, its potential benefits and risks, the monitoring plan, and your responsibilities during its use. Please read this document carefully.<br/><br/>
                    GHK-Cu is being considered as an option to potentially support skin regeneration, reduce signs of aging, and promote hair growth. Its mechanisms include stimulating collagen production, promoting angiogenesis (the formation of new blood vessels), and exerting antioxidant and anti-inflammatory effects. The potential benefits of using GHK-Cu include enhancing wound healing, improving skin texture and elasticity, reducing fine lines and wrinkles, stimulating hair regrowth, reducing inflammation, and protecting skin cells from oxidative damage. Overall, it may enhance skin tone, radiance, and hair health.<br/><br/>
                    While using GHK-Cu, you may experience side effects, including common reactions such as skin irritation, redness, itching, tingling, or temporary discoloration at the application site. Less common but potentially serious risks include allergic reactions, systemic effects if absorbed in significant amounts (affecting copper levels), and unknown risks related to long-term use or higher doses. To ensure your safety and the effectiveness of the therapy, regular monitoring is recommended. This includes a baseline assessment of your medical history, a review of current medications and skincare products, and ongoing evaluations of the application site for side effects. Periodic follow-up appointments, and if necessary, laboratory tests to monitor copper levels, are part of the monitoring plan.<br/><br/>
                    You have the right to discuss alternative options with your healthcare provider, which may include other topical treatments, medical procedures such as laser therapy or microneedling, lifestyle modifications, and other supplements. As a patient, you are responsible for following instructions, reporting side effects, attending follow-up appointments, and avoiding contraindicated products without prior approval.<br/><br/>
                    By signing this consent form, you confirm that you have read and understood the information provided. You have had the opportunity to ask questions, and all of your questions have been answered to your satisfaction. You understand the potential risks and benefits of using GHK-Cu and agree to adhere to the monitoring plan and report any side effects or concerns to your healthcare provider. By signing below, you voluntarily consent to the use of GHK-Cu as recommended.<br/><br/>
                </div>
            `
        }
    },
    methods: {
        handleYesNo(field, value) {
            this.patient[field] = value;
            // Clear detail fields when 'No' is selected
            const detailFields = {
                hasSkinConditions: 'skinConditionsDetails',
                onTreatments: 'treatmentsDetails',
                priorPeptideUse: 'priorPeptideDetails',
                hasAllergies: 'allergiesDetails',
                hasMetabolismDisorders: 'metabolismDisordersDetails',
                hasOrganConditions: 'organConditionsDetails',
                useSubstances: 'substanceDetails',
                hasBalancedDiet: 'dietaryDetails'
            };
            if(field=='hasSymptoms' || field=='isPregnant'){
                this.nextQuestion();
            }
         
            if(field==='hasBalancedDiet' && value === 'Yes'){
                this.patient[detailFields[field]] = '';
                this.nextQuestion();
            } else if(field==='hasBalancedDiet' && value === 'No'){
                return;
            }

            if (value === 'No' && detailFields[field] && field!=='hasBalancedDiet') {
                this.patient[detailFields[field]] = '';
                this.nextQuestion();
            }
        },
        validateBalanceDiet() {
            if (this.patient.hasBalancedDiet === 'No' && !this.patient.dietaryDetails) {
                return;
            }
            this.nextQuestion();
        },
        disqualifyPatient(reason) {
            this.$router.push({ 
                name: 'disqualified', 
                query: { reason }
            });
        },
        nextQuestion() {
            this.questionId++;
            this.scrollToTop();
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        async submitForm() {
    if (this.patient.consent === 'decline') {
        this.$router.push({ name: 'declined' });
        return;
    }

    this.loading = true;
    try {
        const formattedData = {
            formObj: {
                consentsSigned: this.patient.consent === 'accept',

                // Format Q&A pairs with full questions and available options
                Q1: "Please describe your current symptoms and health concerns.",
                A1: this.patient.currentSymptoms || "None provided",

                Q2: "Have you been diagnosed with any skin conditions, wound healing issues, or hair loss disorders? Available Options: Yes, No",
                A2: `${this.patient.hasSkinConditions}${this.patient.hasSkinConditions === 'Yes' ? 
                    ': ' + this.patient.skinConditionsDetails : ''}`,

                Q3: "Are you experiencing symptoms such as delayed wound healing, signs of skin aging (e.g., wrinkles, loss of elasticity), hair thinning, or hair loss? Available Options: Yes, No",
                A3: this.patient.hasSymptoms,

                Q4: "Are you currently on any treatments or medications for skin conditions, wound healing, or hair loss? Available Options: Yes, No",
                A4: `${this.patient.onTreatments}${this.patient.onTreatments === 'Yes' ? 
                    ': ' + this.patient.treatmentsDetails : ''}`,

                Q5: "Have you ever used GHK-Cu (Copper Peptide) or other peptide-based therapies before? Available Options: Yes, No",
                A5: `${this.patient.priorPeptideUse}${this.patient.priorPeptideUse === 'Yes' ? 
                    ': ' + this.patient.priorPeptideDetails : ''}`,

                Q6: "Do you have a history of allergic reactions to peptides, copper, or any topical products? Available Options: Yes, No",
                A6: `${this.patient.hasAllergies}${this.patient.hasAllergies === 'Yes' ? 
                    ': ' + this.patient.allergiesDetails : ''}`,

                Q7: "Do you have any known copper metabolism disorders, such as Wilson's disease or Menkes disease? Available Options: Yes, No",
                A7: `${this.patient.hasMetabolismDisorders}${this.patient.hasMetabolismDisorders === 'Yes' ? 
                    ': ' + this.patient.metabolismDisordersDetails : ''}`,

                Q8: "Do you have any kidney or liver conditions? Available Options: Yes, No",
                A8: `${this.patient.hasOrganConditions}${this.patient.hasOrganConditions === 'Yes' ? 
                    ': ' + this.patient.organConditionsDetails : ''}`,

                Q9: "Are you pregnant, planning to become pregnant, or currently breastfeeding? Available Options: Yes, No",
                A9: this.patient.isPregnant,

                Q10: "Please describe your current skincare or hair care routine, including any products or supplements you are using.",
                A10: this.patient.skinCareRoutine || "None provided",

                Q11: "Do you use tobacco, alcohol, or recreational drugs? Available Options: Yes, No",
                A11: `${this.patient.useSubstances}${this.patient.useSubstances === 'Yes' ? 
                    ': ' + this.patient.substanceDetails : ''}`,

                Q12: "Do you have a balanced diet that includes sources of essential nutrients and antioxidants? Available Options: Yes, No",
                A12: `${this.patient.hasBalancedDiet}${this.patient.hasBalancedDiet === 'No' ? 
                    ': ' + this.patient.dietaryDetails : ''}`,

                Q13: "Informed Consent Acknowledgment. Available Options: Accept, Decline",
                A13: this.patient.consent === 'accept' ? "Patient has acknowledged and consented" : "Patient has declined consent"
            },
            patientInfo: {
                submissionDate: new Date().toISOString()
            },
            pharmacyId: "",
            masterId: `visit_${Date.now()}`,
            company: "newSelf",
            visitType: "ghk-cu"
        };

        const response = await this.$axios.post(
            `${this.baseUrl}/forms/assessment-form/ghk-cu-screening/${this.$route.params.id}`, 
            formattedData
        );

        if (response.data.status === 'success') {
            this.$router.push('/success');
        } else {
            throw new Error('Form submission failed');
        }
    } catch (error) {
        console.error('Form submission error:', error);
        alert('There was an error submitting your form. Please try again.');
    } finally {
        this.loading = false;
    }
}
    }
};
</script>

<style scoped>
.selected{
    background-color: #feffb5;
}

</style>